import React, {Component} from 'react';
import Front from "./Front";

class Group extends Component {

    state = {
        front: [],
    };

    componentDidMount() {
        let front = [];

        this.props.entries.forEach(data => {
            if (data.id in this.props.voting.stats) {
                data.stats = this.props.voting.stats[data.id];
            } else {
                data.stats = 0;
            }
            front.push(data);
        });

        if (this.props.configuration.sort !== "disable") {
            front.sort((a, b) => {
                if (a.stats > b.stats) {
                    return -1;
                }
                if (a.stats < b.stats) {
                    return 1;
                }
                return 0;
            });

        }

        this.setState({
            front: front,
        })
    }


    render() {
        return (
            <div className="Voting-Group">
                <div className="Voting-Group-Front">
                    {this.state.front.map((entry) => {
                        return (
                            <Front
                                key={'entry-'+entry.id}
                                onAskForVote={() => {
                                    this.props.onAskForVote(entry);
                                }}
                                voting={this.props.voting}
                                entry={entry}
                                configuration={this.props.configuration}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default Group;


// WEBPACK FOOTER //
// ./src/Components/Voting/Group.js